const initialState = {
  loading: false,
  data: "",
  addData: [],
  search: "",
  error: null,
  hasMore: true,
  filter: "",
};

const userGoalReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_USER_GOAL_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
        hasMore: true,
        filter: "",
      };
    case "FETCH_USER_GOAL_SUCCESS":
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
        filter: "",
      };
    case "FETCH_USER_GOAL_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
        filter: "",
      };
    case "FETCH_USER_GOAL_SUCCESS_ADD":
      return {
        ...state,
        loading: false,
        addData: [...state.addData, ...action.payload],
        error: null,
        hasMore: action.payload.length > 0,
        filter: "",
      };
    case "USER_GOALS_CHANGE_FILTERS":
      return {
        ...state,
        filter: action.payload,
      };

    case "USER_GOALS_REFRESH":
      return {
        ...state,
        filter: "refresh",
      };

    // case "EMPTY_USER_GOALS":
    //   return {
    //     ...state,
    //     data: "",
    //     addData: "",
    //     hasMore: true,
    //   };

    case "FETCH_USER_GOAL_SEARCH_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
        hasMore: true,
      };
    case "FETCH_USER_GOAL_SEARCH_SUCCESS":
      return {
        ...state,
        loading: false,
        search: action.payload,
        error: null,
      };
    case "FETCH_USER_GOAL_SEARCH_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default userGoalReducer;
